import React from "react";

function Header() {
    return <header>
    <h1 id='topheading'>Find Word Puzzle</h1>
  </header>
}

export default Header;